<template>
  <span v-if="!items.length" class="grey--text">-</span>
  <div v-else class="d-flex flex-wrap">
    <v-chip
      v-for="item in items"
      :key="item.outcome"
      x-small
      outlined
      :color="kindColor(item.kind)"
      class="mr-1 my-1"
      >{{ item.outcome }} {{ item.count
      }}<span v-if="withShare && total" class="ml-1"
        >({{ share(item.count) }}%)</span
      ></v-chip
    >
  </div>
</template>

<script>
// colour groups of parsing_outcomes.outcome_kind
export const KIND_COLORS = {
  ok: "green",
  fetch: "orange",
  ours: "grey",
  parse: "red",
  method: "blue",
};

export default {
  name: "OutcomeChips",
  props: {
    // [{outcome, count, kind}]
    items: { type: Array, default: () => [] },
    // add the share of each outcome in the items
    withShare: { type: Boolean, default: false },
  },
  computed: {
    total() {
      return this.items.reduce((sum, item) => sum + item.count, 0);
    },
  },
  methods: {
    kindColor(kind) {
      return KIND_COLORS[kind] || "grey";
    },
    share(count) {
      const value = (100 * count) / this.total;
      return value < 10 ? value.toFixed(1) : Math.round(value);
    },
  },
};
</script>
